// Webpack Imports
import * as bootstrap from 'bootstrap';
import slick from 'slick-carousel';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
	$('.top-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
	  });
	  $('.top-slider-rtl').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		// fade: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		rtl: true
	  });
	  $('.actions-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			}
		]
	});
	$('.homepage-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		autoplay: true,
	});	
	
	$('.modal').on('hide.bs.modal', function() {
		var memory = $(this).html();
		$(this).html(memory);
	  })


} )();


	(function($) {
		var topBar = $(".top-bar");
		var navBar = $(".titan-nav");
		$(window).scroll(function() {
			var scroll = $(window).scrollTop();
			if (scroll >= 145) {
				topBar.addClass('fixedTopBar');
			} else {
				topBar.removeClass('fixedTopBar');
			}
			if (scroll >= 175) {
				navBar.addClass('fixedNavBar');
			} else {
				navBar.removeClass('fixedNavBar');
			}

		});

		$('.burger').click(function() {
			$('.titan-navbar').toggleClass("open");
			// $('.menu-list').toggleClass("list-open");
		});
		$('.nav-more').on('click', function() {
			$(this).toggleClass('opened');
			$(this).nextAll('ul').toggle();
		})
		$(".language-switcher li").on('click', function(){
			$(this).find('ul').toggleClass('d-block');
		});
		
		$(document).mouseup(function(e) {
			var container = $(".language-switcher li ul");
			if (!container.is(e.target) && container.has(e.target).length === 0) 
			{
				container.removeClass('d-block');
			}
		});
	})(jQuery);


